import { useSize } from 'ahooks';
import { useState, useEffect } from 'react';
import { getRootFontSize } from 'utils/rem';

export const useRootFontSize = () => {
  const [rootFontSize, setRootFontSize] = useState(0);

  const size = useSize(document.body);

  useEffect(() => {
    setRootFontSize(getRootFontSize());
  }, [size]);

  return rootFontSize;
};
